import { render, staticRenderFns } from "./None404.vue?vue&type=template&id=b1e6a4d2&scoped=true&"
import script from "./None404.vue?vue&type=script&lang=js&"
export * from "./None404.vue?vue&type=script&lang=js&"
import style0 from "./None404.vue?vue&type=style&index=0&id=b1e6a4d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e6a4d2",
  null
  
)

export default component.exports